import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Image = styled.div`
  width: 100px;
  height: 100px;
  background-size: cover;
  cursor: pointer;
  border-radius: 10px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
